module.exports = __webpack_public_path__ + "img/studying.05c24001.jpg";